import component from "./en/component";
import layout from "./en/layout";
import pages from "./en/pages";

export default {
  ...layout,
  ...pages,
  ...component,
};
